import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { useMedia, useModalOpened } from 'sb-hooks'
import { isNotEmpty, constants } from 'common/helpers'
import queueNonSubscribedDecorator from 'components/queueNonSubscribed/queueNonSubscribedDecorator/queueNonSubscribedDecorator'

import ContentLoader from 'components/loaders/ContentLoader/ContentLoader'
import CloseIcon from 'components/ui/CloseIcon/CloseIcon'
import Title from 'components/_new/typography/deprecated/Title/Title'
import EmptyText from 'pages/QueuePage/NonSubscribed/EmptyText/EmptyText'
import Product from 'pages/QueuePage/NonSubscribed/Mobile/Product/Product'
import Offer from 'pages/QueuePage/NonSubscribed/Offer/Offer'
import Queue from 'components/Queue/Queue'

import messages from './messages'
import s from './QueueWidget.scss'


const QueueWidget = (props) => {
  const { isFetching, firstItem, restItems, isEmpty, addToQueuePlacement, isSubscriptionCancelled, onClose } = props

  const firstProduct = !isEmpty && firstItem && isNotEmpty(firstItem.products) ? firstItem.products[0] : {}

  const { isMobile } = useMedia()

  useModalOpened(isMobile)

  return (
    <div className={s.root} data-testid={constants.testIds.queueWidget.root}>
      <div className={s.closeContainer}>
        <CloseIcon
          onClick={onClose}
          className={s.closeIcon}
          whiteColor
          dataTestId={constants.testIds.queueWidget.closeButton}
        />
      </div>
      <div className={s.container}>
        <Title message={messages.title} className={s.title} size="sm" uppercase />
        {
          isFetching ? (
            <ContentLoader />
          ) : (
            <Fragment>
              {
                isEmpty ? (
                  <EmptyText className={s.emptyText} />
                ) : (
                  <Fragment>
                    <Product
                      placement={addToQueuePlacement}
                      index={0}
                      year={firstItem.year}
                      month={firstItem.month}
                      {...firstProduct}
                    />
                    <Offer
                      className={s.offer}
                      isMobile={isMobile}
                      isSubscriptionCancelled={isSubscriptionCancelled}
                      placement="queue widget"
                    />
                    <Title message={messages.futurePurchases} size="sm" uppercase />
                  </Fragment>
                )
              }
              <Queue
                placement={addToQueuePlacement}
                trackingNumberPlacement={addToQueuePlacement}
                items={restItems}
                emptyQueueFirstCellPlus={isEmpty}
                startIndex={isEmpty ? 0 : 1}
              />
            </Fragment>
          )
        }
      </div>
    </div>
  )
}

QueueWidget.propTypes = {
  onClose: PropTypes.func.isRequired,
  firstItem: PropTypes.object,
  restItems: PropTypes.arrayOf(PropTypes.object),
  isEmpty: PropTypes.bool,
  addToQueuePlacement: PropTypes.string,
  isSubscriptionCancelled: PropTypes.bool,
}


export default queueNonSubscribedDecorator(QueueWidget)
